// extracted by mini-css-extract-plugin
export default {"top":"styles_top__CVz0Q","subTitle":"styles_subTitle__-0Ao2","btnBox":"styles_btnBox__Tcx3i","hint":"styles_hint__T-ShO","langs":"styles_langs__vaNoW"};